
<template>
    <div>
        <el-dialog title="工程进度" :visible.sync="dialogProgress">
            <div class="container" style="margin-top:15px;">
              <el-row v-if="prolist.length==0" style="text-align: center;font-size: 20px;">
                <span>暂时没有记录!</span>
              </el-row>
                <el-row  v-for="item in prolist" :key="item.key">
                    <el-col :span="5" style="text-align: center;"> 
                        <img :src="item.avatar?getimgpath(item.avatar):item.headimgurl" style="width: 60px;border-radius: 100%;"/>
                        </el-col>
                    <el-col :span="5" style="line-height: 60px;font-size: 17px;">
                        {{item.userName?item.userName:'系统操作'}}
                    </el-col>
                    <el-col :span="5" style="line-height: 60px;font-size: 17px;">
                        {{item.typeName}}
                    </el-col>
                    <el-col :span="9" style="line-height: 60px;font-size: 17px;">
                            {{settime(item.createTime)}}
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>


<script>
    import {getProgInfo} from '@/api/admin/taskManagement'
    import {getImgLink} from '@/config/env'
    import { objKeySort } from '@/util/ajaxsign'
    import {dateOnce} from '@/util/dateT'
    export default {
        data() {
            return {
                dialogProgress : false,
                prolist : []
            }
        },
        created() {
            this.getdicts()
        },
       
        methods: {
            //设置展示
            setsataus(data){
                this.dialogProgress = true;
                this.getCompanyInfo(data);
            },
          
            //项目详情数据请求
            getCompanyInfo(data){
                getProgInfo(objKeySort({projectId:data})).then(response =>{
                    this.prolist = response.data.data;
                })
            },

            //默认时间
            settime(data){
               return dateOnce(data)
            },

            //获取图片信息
            getimgpath(data){
              return getImgLink(data);
            }
        }
    }
</script>
<style lang="scss" scoped>
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>